module.exports = __webpack_public_path__ + "img/breast-cancer-leaflet.f972ad13.jpg";